import React from 'react';
import Field from '../../Field';
import { Radio, GroupLabel } from '../../FormControls';
import { useMoneyFormat } from '../../../context/LocaleContext';
import s from './eventDrawer.module.css';
import { DecimalInput } from '../../RegionInputs';

// Pricing comes last: it is the part that generates money, and after the
// schedule the teacher has decided what the lesson is before what it costs.

export default function PricingSection({ form, set, priceError = null }) {
  // The price box is the Region's (`DecimalInput`, #526): `16,95` in
  // Germany. A third decimal is truncated one level up, by `set` in
  // src/hooks/useEventForm.js (#308). The zero is written in the studio's
  // currency.
  const formatMoney = useMoneyFormat();

  return (
    <div className={s.section}>
      <GroupLabel>Event Pricing</GroupLabel>

      <Radio
        name="price" label="Student lesson price / package time"
        help="Uses package time first if the student has any available"
        checked={form.pricingRule === 'student'}
        onChange={() => set('pricingRule', 'student')}
      />
      <Radio
        name="price" label={`No charge (${formatMoney(0)})`}
        checked={form.pricingRule === 'none'}
        onChange={() => set('pricingRule', 'none')}
      />
      <Radio
        name="price" label="Specify event price"
        checked={form.pricingRule === 'fixed'}
        onChange={() => set('pricingRule', 'fixed')}
      />

      {form.pricingRule === 'fixed' ? (
        <div className={[s.narrower, s.spacedTight].join(' ')}>
          {/* `priceError` is computed in useEventForm.js, which has the
              studio's currency (#171): a price past MAX_MONEY_MINOR is refused
              here rather than reaching the write as a bare permission-denied. */}
          <Field label="Event price" error={priceError}>
            <DecimalInput
              className={s.input}
              placeholder="0.00"
              value={form.priceOverride}
              onChange={(e) => set('priceOverride', e.target.value)}
            />
          </Field>
        </div>
      ) : null}
    </div>
  );
}
